export enum EntityType {
    STUDENT = "STUDENT",
    LESSON = "LESSON",
    INSTRUCTOR = "INSTRUCTOR"
}
